import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const References = () => {
  const referencesNE3 = [
    "Memmingen, Wetzlar, Fulda, München, Bamberg",
    "Lahn-Dill-Kreis, Hanau, Frankfurt am Main",
    "Kierspe-Valbert, Wiesbaden (Vodafone), Bad Salzschlirf, Melsungen",
    "Marburg-Biedenkopf-Kreis, Wiesbaden, Bad Honnef, Hammersbach",
    "Fulda, Thüringen",
    "Thüringen",
    "Limburg an der Lahn"
  ];

  const referencesNE4 = [
    "Mannheim, Heidelberg, Berlin, Zwickau",
    "Frankfurt und Umgebung"
  ];

  return (
    <section id="references" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base text-amber-500 font-semibold tracking-wide uppercase">Referenzen</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            Vertrauen durch Leistung
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-500 mx-auto">
            Erfolgreich abgeschlossene Projekte in ganz Deutschland.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* NE3 References */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-bold border-b-2 border-slate-200 pb-3 mb-6 flex items-center">
              <span className="bg-slate-900 text-white px-3 py-1 rounded text-sm mr-3">NE3</span>
              Tiefbau & Hausanschlüsse
            </h3>
            <div className="space-y-4">
              {referencesNE3.map((locations, idx) => (
                <div key={idx} className="bg-slate-50 p-4 rounded-lg border border-slate-100 flex items-start shadow-sm">
                  <SafeIcon name="MapPin" className="h-5 w-5 text-amber-500 mt-0.5 mr-3 flex-shrink-0" />
                  <p className="text-slate-800 font-medium leading-relaxed">{locations}</p>
                </div>
              ))}
            </div>
          </motion.div>

          {/* NE4 References */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
             <h3 className="text-xl font-bold border-b-2 border-slate-200 pb-3 mb-6 flex items-center">
              <span className="bg-amber-500 text-slate-900 px-3 py-1 rounded text-sm mr-3">NE4</span>
              Inhouse & Glasfaserinstallation
            </h3>
            <div className="space-y-4">
              {referencesNE4.map((locations, idx) => (
                <div key={idx} className="bg-slate-50 p-4 rounded-lg border border-slate-100 flex items-start shadow-sm">
                  <SafeIcon name="MapPin" className="h-5 w-5 text-amber-500 mt-0.5 mr-3 flex-shrink-0" />
                  <p className="text-slate-800 font-medium leading-relaxed">{locations}</p>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default References;